import { EnvGlobalsHandler } from "../../EnvGlobalsHandler";
import { ClientFunnelGameStates } from "../../../tracking/clientFunnel/ClientFunnelGameStates";
import { BasicSmartfoxConstants } from "../BasicSmartfoxConstants";
import { SmartfoxEvent } from "../../event/SmartfoxEvent";
import { BasicModel } from "../../model/BasicModel";
import { BasicSmartfoxClient } from "../../model/components/BasicSmartfoxClient";
import { SimpleCommand } from "./../../../commanding/SimpleCommand";
import { ClientFunnelTrackingController } from "../../../tracking/clientFunnel/ClientFunnelTrackingController";

import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger("BasicJoinedRoomCommand");
export class BasicJoinedRoomCommand extends SimpleCommand {
    public execute(commandVars: any = null): void {
        let event: SmartfoxEvent = (<SmartfoxEvent>commandVars);

        if (event.params[0] === BasicSmartfoxClient.LOBBY_ROOM_NAME) {
            ClientFunnelTrackingController.getInstance().trackState(ClientFunnelGameStates.VERSION_CHECK_SEND);
            BasicModel.smartfoxClient.sendMessage(BasicSmartfoxConstants.C2S_VERSION_CHECK, [EnvGlobalsHandler.globals.buildNumberGame, 'web-html5', '', EnvGlobalsHandler.globals.sessionId]);
        } else {
            logger.error("Joined room name != " + BasicSmartfoxClient.LOBBY_ROOM_NAME + " : " + event.params[0]);
        }
    }
}

